module.exports = __webpack_public_path__ + "static/media/groupSettingBlackIcon.e83317e6.svg";